import { BookingWidget } from "@/components/BookingWidget";
import { IMAGES } from "@/lib/constants";
import { MapPinned, ArrowRight } from "lucide-react";

const ROUTES = [
  ["London", "Manchester", 200], ["London", "Birmingham", 126], ["London", "Oxford", 60],
  ["London", "Cambridge", 64], ["London", "Bristol", 120], ["Manchester", "Liverpool", 35], ["Birmingham", "London", 126],
];

export default function Outstation() {
  return (
    <div>
      <section className="relative bg-navy">
        <img src={IMAGES.countryside} alt="Road" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-navy/65" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
          <div className="grid items-center gap-10 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white"><MapPinned size={14} className="text-brand" /> Outstation</span>
              <h1 className="mt-4 font-heading text-4xl font-bold text-white lg:text-5xl">Travel Across the UK Without the Stress</h1>
              <p className="mt-4 max-w-md text-slate-300">Comfortable long-distance journeys with fixed fares, professional drivers and optional return trips.</p>
            </div>
            <div className="lg:col-span-7"><BookingWidget initialTab="return" /></div>
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-heading text-2xl font-bold text-navy">Popular routes</h2>
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {ROUTES.map(([from, to, mi]) => (
            <div key={from + to} className="flex items-center justify-between rounded-2xl border border-slate-200 bg-white p-5">
              <div className="flex items-center gap-2 font-heading font-semibold text-navy">{from} <ArrowRight size={16} className="text-brand" /> {to}</div>
              <span className="text-sm text-slate-500">~{mi} mi</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
